import UserTypes from './user.types'
import { deleteDataInArray } from '../../utils/function.utils'
const INITIAL_STATE = {
	data: null,
	total: 0,
	page: 1,
}

const UserReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case UserTypes.GET_USERS:
			return {
				...state,
				...payload,
			}
		case UserTypes.DELETE_USER:
			return {
				...state,
				data: deleteDataInArray(state.data, payload),
			}
		default:
			return state
	}
}

export default UserReducer
